/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Live_GamesInputs */

const th_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขณะนี้ยังไม่มีเกมที่กำลังแข่งขัน`)
};

const en_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No games are being played right now.`)
};

const ja_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在プレー中の試合はありません。`)
};

const zh_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前没有正在进行的比赛。`)
};

const es_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahora mismo no se está jugando ningún partido.`)
};

const pt_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum jogo está sendo disputado agora.`)
};

const id_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada pertandingan yang sedang berlangsung.`)
};

const fr_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun match n’est en cours actuellement.`)
};

const tl_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang larong kasalukuyang ginaganap.`)
};

const vi_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiện không có trận nào đang đấu.`)
};

const ko_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지금 진행 중인 경기가 없습니다.`)
};

const de_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerade wird kein Spiel gespielt.`)
};

const ru_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сейчас не идёт ни один матч.`)
};

const tr_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şu anda oynanan maç yok.`)
};

const it_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna partita in corso.`)
};

const pl_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Żaden mecz nie jest teraz rozgrywany.`)
};

const uk_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зараз не грається жоден матч.`)
};

const hi_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस समय कोई मैच नहीं खेला जा रहा।`)
};

const ar_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد مباراة تُلعب الآن.`)
};

const ms_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada perlawanan sedang berlangsung.`)
};

const bn_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এখন কোনও খেলা চলছে না।`)
};

const zh_tw2_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前沒有正在進行的比賽。`)
};

const zh_hk2_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前沒有正在進行的比賽。`)
};

const ur_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس وقت کوئی میچ نہیں ہو رہا۔`)
};

const fa_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هم‌اکنون بازی‌ای در جریان نیست.`)
};

const sw_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna mchezo unaoendelea sasa.`)
};

const nl_no_live_games = /** @type {(inputs: No_Live_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er wordt nu geen wedstrijd gespeeld.`)
};

/**
* | output |
* | --- |
* | "No games are being played right now." |
*
* @param {No_Live_GamesInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const no_live_games = /** @type {((inputs?: No_Live_GamesInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Live_GamesInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_no_live_games(inputs)
	if (locale === "ja") return ja_no_live_games(inputs)
	if (locale === "zh") return zh_no_live_games(inputs)
	if (locale === "es") return es_no_live_games(inputs)
	if (locale === "pt") return pt_no_live_games(inputs)
	if (locale === "id") return id_no_live_games(inputs)
	if (locale === "fr") return fr_no_live_games(inputs)
	if (locale === "tl") return tl_no_live_games(inputs)
	if (locale === "vi") return vi_no_live_games(inputs)
	if (locale === "ko") return ko_no_live_games(inputs)
	if (locale === "de") return de_no_live_games(inputs)
	if (locale === "ru") return ru_no_live_games(inputs)
	if (locale === "tr") return tr_no_live_games(inputs)
	if (locale === "it") return it_no_live_games(inputs)
	if (locale === "pl") return pl_no_live_games(inputs)
	if (locale === "uk") return uk_no_live_games(inputs)
	if (locale === "hi") return hi_no_live_games(inputs)
	if (locale === "ar") return ar_no_live_games(inputs)
	if (locale === "ms") return ms_no_live_games(inputs)
	if (locale === "bn") return bn_no_live_games(inputs)
	if (locale === "zh-TW") return zh_tw2_no_live_games(inputs)
	if (locale === "zh-HK") return zh_hk2_no_live_games(inputs)
	if (locale === "ur") return ur_no_live_games(inputs)
	if (locale === "fa") return fa_no_live_games(inputs)
	if (locale === "sw") return sw_no_live_games(inputs)
	if (locale === "nl") return nl_no_live_games(inputs)
	return en_no_live_games(inputs)
});